import type { MediaAttachmentsListQueryParams } from '@/types/mediaAttachmentsApiTypes';

export const MEDIA_ATTACHMENTS_QUERY_ROOT = 'media-attachments' as const;

export function mediaAttachmentsListQueryKey(params: MediaAttachmentsListQueryParams) {
  return [MEDIA_ATTACHMENTS_QUERY_ROOT, 'list', JSON.stringify(params)] as const;
}

export function mediaAttachmentDetailQueryKey(uuid: string) {
  return [MEDIA_ATTACHMENTS_QUERY_ROOT, 'detail', uuid] as const;
}
